/**
 * Menentukan bentuk layar Check In/Out dari jawaban server — MURNI.
 *
 * Dipisahkan dari komponen karena inilah keputusan yang salah pada pilot 16 Agustus 2026, dan
 * keputusan yang salah di dalam komponen tidak dapat diuji tanpa merender.
 *
 * Aturannya satu kalimat: **klien tidak menebak.** Hari kerja, zona waktu, dan sesi terbuka
 * lintas tengah malam ditentukan server memakai kebijakan organisasi; fungsi ini hanya
 * menerjemahkan jawabannya menjadi bentuk layar.
 */

/** Jawaban server: `null` berarti belum ada kebijakan absensi aktif. */
export type ServerNextAction = 'check_in' | 'check_out' | null;

/** Bentuk layar. `unavailable` = status tidak diketahui, dan itu dinyatakan apa adanya. */
export type CheckMode = 'CHECK_IN' | 'CHECK_OUT' | 'unavailable';

/**
 * `nextAction` dari `GET /api/me/attendance/today` menjadi bentuk layar.
 *
 * `null` TIDAK jatuh ke Check In. Versi sebelumnya melakukannya — dan bagi orang yang sesinya
 * masih terbuka, itu menawarkan tombol yang pasti ditolak server sambil menyembunyikan tombol
 * yang sebenarnya ia butuhkan. Menampilkan ketidaktahuan lebih berguna daripada menampilkan
 * tebakan yang keliru.
 */
export function resolveCheckMode(nextAction: ServerNextAction): CheckMode {
  if (nextAction === 'check_out') return 'CHECK_OUT';
  if (nextAction === 'check_in') return 'CHECK_IN';
  return 'unavailable';
}

/**
 * Bentuk layar saat permintaan status GAGAL.
 *
 * Dipisah dari `resolveCheckMode` supaya perbedaannya eksplisit: gagal ≠ tidak ada kebijakan,
 * meski keduanya berakhir pada layar yang sama. Menyatukannya akan membuat perubahan pada salah
 * satu diam-diam mengubah yang lain.
 */
export function checkModeOnError(): CheckMode {
  return 'unavailable';
}
